import { User } from "../generated/graphql"

export const userName = (user: Pick<User, "firstName" | "lastName">) => {
  return [user?.firstName, user?.lastName].filter(Boolean).join(" ")
}
